import { Schema } from 'effect';

/**
 * Every thing a set of parameters can be about, as the engine names them.
 *
 * The outermost of the three vocabularies an attribute path is written in: a target holds components, and a component holds attributes. `modl` is the model as a whole, `karm` the frame, `rm1` the first sash.
 *
 * Worth reading twice: `modl` here and `mdl` in {@link ComponentTypes} are different values in different lists, and both appear in the same path. Neither is a misspelling of the other.
 *
 * The frontend's copy of the backend's own `TargetType`, kept strict and failing the same way the other two do when the lists drift. Kept in the backend's order rather than sorted.
 */
export const TargetTypes = Schema.Literals(['modl', 'karm', 'rm1', 'rm2', 'rm3', 'rm4', 'rm5', 'rm6', 'rm7', 'rm8', 'rm9', 'rm10', 'rm11', 'rm12', 'rm13', 'rm14', 'rm15', 'rm16', 'rm17', 'rm18', 'rm19', 'rm20', 'rm21', 'rm22', 'rm23', 'rm24', 'rm25', 'rmx', 'prfs', 'rmi', 'rmu']);

/** One of the things a set of parameters can be about. */
export type ITargetType = typeof TargetTypes.Type;
